module.exports = __webpack_public_path__ + "img/clipartproducts.3f4e800c.png";